import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userManagementBaseUrl, userManagement } from "../endpoints"; // adjust path if needed

export const packageMasterService = createApi({
  reducerPath: "packageMasterService",
  baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
  tagTypes: ["PackageMaster"],
  endpoints: (builder) => ({

    // Get all packages with pagination
    getAllPackagesWithPagination: builder.mutation({
      query: (body) => ({
        url: `${userManagement.packageMasterController.getAllPackagesWithPagination}/${body.page}/${body.offset}?orderBy=${body.orderBy}`,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),

    // Get all packages without pagination
    getAllPackages: builder.mutation({
      query: (body) => ({
        url: `${userManagement.packageMasterController.getAllPackages}`,
        method: "GET",
        // headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),

    // Get package by ID
    getPackageById: builder.mutation({
      query: (body) => ({
        url: `${userManagement.packageMasterController.getPackageById}${body.id}`,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),

    // Save package
    savePackage: builder.mutation({
      query: (body) => ({
        url: `${userManagement.packageMasterController.savePackage}`,
        method: "POST",
        headers: { Authorization: `Bearer ${body.token}` },
        body: body.payload,
      }),
    }),

    // Update package by ID
    updatePackageById: builder.mutation({
      query: (body) => ({
        url: `${userManagement.packageMasterController.updatePackageById}${body.id}`,
        method: "PUT",
        headers: { Authorization: `Bearer ${body.token}` },
        body: body.payload,
      }),
    }),

    // Delete package by ID
    deletePackageById: builder.mutation({
      query: (body) => ({
        url: `${userManagement.packageMasterController.deletePackageById}${body.id}`,
        method: "DELETE",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),

    // Search packages (with filters)
    searchPackages: builder.mutation({
      query: (body) => ({
        url: `${userManagement.packageMasterController.searchPackages}`,
        method: "POST",
        headers: { Authorization: `Bearer ${body.token}` },
        body: body.payload,
      }),
    }),
  }),
});
export const {
  useGetAllPackagesWithPaginationMutation,
  useGetAllPackagesMutation,
  useGetPackageByIdMutation,
  useSavePackageMutation,
  useUpdatePackageByIdMutation,
  useDeletePackageByIdMutation,
  useSearchPackagesMutation,
} = packageMasterService;
